<template>
  <div>
    <q-form-item
      :prop="element.key"
      :label="element.caption"
    >
      <q-select
        v-model="model[element.key]"
        filterable
        :multiple="element.multiple"
        :disabled="element.disabled"
        :placeholder="element.placeholder"
      >
        <q-option
          v-for="item in element.items"
          :key="item.id"
          :label="item.caption"
          :value="item.id"
        />
      </q-select>

<!--      <q-radio-group-->
<!--        v-else-->
<!--        v-model="model[element.key]"-->
<!--        :disabled="element.disabled"-->
<!--      >-->
<!--        <q-radio-->
<!--          v-for="item in element.items"-->
<!--          :key="item.id"-->
<!--          :label="item.caption"-->
<!--        >-->
<!--          {{ item.caption }}-->
<!--        </q-radio>-->
<!--      </q-radio-group>-->
    </q-form-item>
  </div>
</template>

<script>
  import elementGeneratorMixin from "./elementGeneratorMixin";

  export default {
    name: "SelectorItem",
    mixins: [elementGeneratorMixin],
  }
</script>

<style scoped>

</style>